import { render, staticRenderFns } from "./insertExamStudent.vue?vue&type=template&id=575f9b1c&scoped=true"
import script from "./insertExamStudent.vue?vue&type=script&lang=js"
export * from "./insertExamStudent.vue?vue&type=script&lang=js"
import style0 from "./insertExamStudent.vue?vue&type=style&index=0&id=575f9b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575f9b1c",
  null
  
)

export default component.exports